module.exports = __webpack_public_path__ + "media/bootstrap-icons/camera-fill-805183ac.svg";